const API = process.env.REACT_APP_BACKEND_URL;

export function learnerId() {
  let id = "";
  try {
    id = localStorage.getItem("stoicos.physics.learner") || "";
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2));
      localStorage.setItem("stoicos.physics.learner", id);
    }
  } catch { id = "anonymous-learner"; }
  return id;
}

export const loc = (v, lang = "en") => (v && typeof v === "object" ? v[lang] || v.en || "" : v || "");

async function get(path) {
  let headers = {};
  try {
    const t = localStorage.getItem("stoicos.admin.token");
    if (t) headers = { Authorization: `Bearer ${t}` };
  } catch { /* ignore */ }
  const r = await fetch(`${API}/api/academy/physics${path}`, { headers });
  if (!r.ok) throw new Error(`GET ${path} failed`);
  return r.json();
}

async function send(method, path, body) {
  const r = await fetch(`${API}/api/academy/physics${path}`, {
    method, headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!r.ok) {
    const t = await r.json().catch(() => ({}));
    const err = new Error(typeof t.detail === "string" ? t.detail : "Request failed");
    err.detail = t.detail;
    throw err;
  }
  return r.json();
}

export const fetchCourse = () => get("/course");
export const fetchProgress = () => get(`/progress/${learnerId()}`).catch(() => ({ records: [] }));
export async function deleteLessonWork(lessonSlug) {
  const r = await fetch(`${API}/api/academy/physics/progress/${learnerId()}/${lessonSlug}`, { method: "DELETE" });
  return r.ok;
}
export const saveProgress = (payload) => send("POST", `/progress/${learnerId()}`, payload);
export const resetProgress = () => send("DELETE", `/progress/${learnerId()}`);

let _termsCache = null;
export function fetchTerms() {
  if (!_termsCache) _termsCache = get("/terms").then((d) => d.terms || []);
  return _termsCache;
}
let _interventionsCache = null;
export function fetchInterventions() {
  if (!_interventionsCache) _interventionsCache = get("/interventions").then((d) => d);
  return _interventionsCache;
}

export const fetchAbilities = () => get("/abilities");
export const fetchPracticeProgram = () => get("/practice-program");

export const fetchRecords = () => get(`/records/${learnerId()}`);
export const createRecord = (payload) => send("POST", `/records/${learnerId()}`, payload);
export const updateRecord = (id, payload) => send("PATCH", `/records/${learnerId()}/${id}`, payload);
export const deleteRecord = (id) => send("DELETE", `/records/${learnerId()}/${id}`);

export const fetchPracticeLog = () => get(`/practice-log/${learnerId()}`);
export const addPracticeLog = (practiceId, note) => send("POST", `/practice-log/${learnerId()}`, { practiceId, note });

export const fetchAbilityEvidence = () => get(`/ability-evidence/${learnerId()}`);
export const submitAbilityEvidence = (abilityId, evidence) => send("POST", `/ability-evidence/${learnerId()}`, { abilityId, evidence });

export const fetchChamber = () => get("/chamber");
export const fetchChamberSession = () => get(`/chamber/session/${learnerId()}`);
export const saveChamberStage = (stageId, responses) => send("POST", `/chamber/session/${learnerId()}`, { stageId, responses });
export const submitChamber = () => send("POST", `/chamber/submit/${learnerId()}`);
